import React from "react"
import InfograficaPage3 from '../../components/mobile/Capitolo1/InfograficaPage3'

const Page3Mobile = ({ backgroundColor, openPercent, color, innerRef }) => {
  return (
    <div ref={innerRef} style={{ background: backgroundColor, color: color }} className="grid-cols-4 md:grid-cols-8">
      <div className='col-4 md:col-6 md:col-offset-left-1'>
        <div>
          <div className='col-1' style={{ height: 2, backgroundColor: '#FF6B29'}}></div>
          <div className='mt-2 font-20 line-height-26'>
            L’elettrico potrebbe essere la soluzione per diminuire l’impatto ambientale
            dei veicoli a motore: questi trasporti non emettono gas di scarico inquinanti
            e l’elettricità che alimenta la trazione può essere generata da fonti
            energetiche rinnovabili. Il tema dell’elettricità come fonte di
            alimentazione dei veicoli è quindi tornato, sempre più, nel dibattito
            pubblico e nei piani dei principali governi del mondo.
          </div>
          <div className='mt-2 font-20 line-height-26'>
            Il Regno Unito ha annunciato che vieterà la vendita delle auto
            con motori a benzina o diesel a partire dal 2040 (e la Francia
            ha fatto lo stesso), consentendo – entro i successivi 10 anni –
            la circolazione ai soli veicoli a emissioni zero; la stessa camera
            bassa del parlamento olandese ha approvato una legge che vieta la vendita
            di veicoli del genere a partire dal 2025.
          </div>
          <div className='mt-2 font-20 line-height-26'>
            Anche in Italia – un Paese in cui nei due principali centri,
            Roma e Milano, ogni automobilista trascorre in media oltre 200 ore all’anno in macchina,
            con una media di 1.3 persone per auto – si sta cercando di incentivare
            l’elettrico: la legge di Bilancio 2019 (Legge 145/2018) ha infatti introdotto
            incentivi fino a 6mila euro per l’acquisto di veicoli elettrici o ibridi, e
            detrazioni fiscali del 50 per cento delle spese sostenute.
          </div>
          <div className='mt-5 barra-arancio'></div>
          <div className='mt-3'>
            <div className='font-family-acumin font-weight-500 font-22 line-height-26'>
              Il futuro (incerto?)
              del carburante
            </div>
            <div className='mt-2 font-18 line-height-22'>
              Sebbene il numero di veicoli aumenterà, la domanda di carburante diminuirà
              entro il 2040, passando da 23 MMb/g fino a 18 – grazie ai progressivi miglioramenti nei
              consumi dei veicoli elettrici e della mobilità condivisa (es. car-sharing).
            </div>
            <div className='mt-5 text-center'>
              <InfograficaPage3 />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Page3Mobile
